import { render } from "./BeforeTest.vue?vue&type=template&id=752334ea&scoped=true"
import script from "./BeforeTest.vue?vue&type=script&lang=js"
export * from "./BeforeTest.vue?vue&type=script&lang=js"

import "./BeforeTest.vue?vue&type=style&index=0&id=752334ea&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752334ea"]])

export default __exports__